import React from 'react';
import { Container } from 'react-bootstrap';
import { FormHeading, Well } from '../../form';
import LoginForm from '../../login';
import AdminLoginForm from './AdminLoginForm';
import attemptAdminLogin from './attemptAdminLogin';
import schema from './schema';

export const AdminLoginPage: React.FC = () => (
  <Container>
    <Well>
      <FormHeading title="Administrator Login" backPath="/" />
      <LoginForm
        initialValues={{ password: '' }}
        validationSchema={schema}
        promise={attemptAdminLogin}
        redirectPath="/admin"
      >
        <AdminLoginForm />
      </LoginForm>
    </Well>
  </Container>
);
